// Texty karty z API objektu (productCardRender.js).
export default {
  cart: 'Do košíku',
  detail: 'Zobrazit detail',
  /** aria-label CTA: „Do košíku <název produktu>" */
  cartAria: (name) => 'Do košíku' + ' ' + (name || ''),
  /** nativní název vlaječky akční nabídky (po dobu kampaně ho přepíše deštník) */
  flagAction: 'Slevoakce',
};
